export default __webpack_public_path__ + "static/media/student3.a36e78a7.gif";